import React from "react";
import img01 from "../../assets/img/images/about-thread.svg";
import img02 from "../../assets/img/images/about_img02.png";
import { Link } from "react-router-dom";

const Tokenomics = (props) => {
  return (
    <section id="tokenomics" className="tokenomics-area pt-130 pb-130">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="tokenomics-content wow">
              <div className="section-title mb-30">
                {/* <span className="sub-title">Who we are</span> */}
                <h2 className="title">
                  Tokenomics
                </h2>
              </div>
              <p>
              Max Total Supply ----------- 1,000,000,000,000,000 $KLIA
              </p>
              <p>
              Presale 30% 	-----------  300.000.000.000.000 $KLIA
              </p>
              <p>
              Presale-time:  -----------  30 days or when the 30% is sold out
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tokenomics;
